import { atom, RecoilState } from 'recoil';

export const clientState: RecoilState<string | null> = atom({
    key: "client",
    default: null as string | null,
});

export const languageState: RecoilState<string | null> = atom({
    key: "language",
    default: null as string | null,
});